import React, { useState, useEffect } from "react";
import EditEmployeePage from "../../../../../entities/DashboardPage/HRModule/Employees/Edit";
import { useLocation, useNavigate } from "react-router-dom";
import AuthService from "../../../../../api/AuthService";
import { useAlert } from "../../../../../context/AlertContext";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import { employeeService } from "../../../../../api";
import ViewEmployeePage from "../../../../../entities/DashboardPage/HRModule/Employees/View";
import { getBlobErrorMessage } from "../../../../../utils/blobError";

const EmployeeView = () => {
  const [data, setData] = useState("");
  const [imgUrl, setimgUrl] = useState("");
  const [loading, setLoading] = useState();
  const [emailSending, setEmailSending] = useState(false);
  const { showAlert } = useAlert();
  const { state } = useLocation();
  const { item } = state || {};
  const navigate = useNavigate();
  const [departmentData, setDepartmentData] = useState([]);
  const [documents, setDocuments] = useState(item?.docs);
  const [payslip, setPayslip] = useState([]);
  const [oneEmloyeeData, setOneEmployeeData] = useState({});
  const [projectList, setProjectList] = useState([]);

  useEffect(() => {
    getDepartment();
    getPayslipSetting();
    setDocData();
    getProjectList();
  }, []);

  const setDocData = () => {
    setDocuments((prevItemsArg) => {
      const updatedItems = [...(prevItemsArg || [])]; // Create a shallow copy of the array

      // Assume 'result.data' is an array of URLs and 'data' contains names
      item?.docs.forEach((url, index) => {
        if (updatedItems[index]) {
          // If the index exists, update the existing entry
          updatedItems[index] = {
            url: url?.url, // Assign the URL
            name: url?.name, // Assign the name
          };
        } else {
          // If the index does not exist, add a new entry
          updatedItems.push({
            url: url?.url,
            name: url?.name,
          });
        }
      });

      return updatedItems;
    });
  };

  const handleUrl = async (data) => {
    try {
      const result = await AuthService.handleSingleImgUrl(data);
      if (result) {
        setimgUrl(result.data[0]);
      }
    } catch (error) {
      // console.error("ssError occurred:", error);
    }
  };
  const handleMultipleUrl = async (data, i) => {
    try {
      const result = await AuthService.handleSingleImgUrl(data);
      if (result) {
        showAlert(result?.message, "success");

        setDocuments((prevItemsArg) => {
          const updatedItems = [...(prevItemsArg || [])]; // Create a shallow copy of the array

          if (updatedItems[i]) {
            // If the index exists, update the existing entry
            updatedItems[i].url = result?.data[0] || ""; // Assign the URL to the correct index
            updatedItems[i].name = data?.name || ""; // Assign the name to the correct index
          } else {
            // If the index does not exist, add a new entry
            updatedItems.push({
              url: result?.data[0] || "",
              name: data?.name || "",
            });
          }

          return updatedItems; // Return the updated array
        });
      }
    } catch (error) {
      // console.error("Error occurred:", error);
    }
  };

  // ------------------------------------------------------------------------------------------------
  // Calling a api for update a employee information
  // ------------------------------------------------------------------------------------------------

  const getOneEmployee = async (id) => {
    try {
      setLoading(true);
      const result = await AuthService.getEmployee(id);
      if (result?.success === true) {
        setOneEmployeeData(result?.data);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const updateEmployeeInfo = async (
    data,
    user,
    mobile,
    cCode,
    emergency,
    emergencyCode,
    workplace,
    workplaceCode,
    nationalities
  ) => {
    try {
      setLoading(true);
      const result = await employeeService.update(
        data,
        imgUrl,
        user,
        documents,
        mobile,
        cCode,
        emergency,
        emergencyCode,
        workplace,
        workplaceCode,
        nationalities
      );
      if (result?.success === true) {
        setLoading(false);
        showAlert(result?.message, "success");
        getOneEmployee(item?._id);
        // navigate("/dashboard/manageStaff");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error?.message, "error");
    }
  };


  const CountryCode = async (country) => {
    try {
      const result = await AuthService.getCountry(country);
      if (result?.success) {
        setData(result?.data);
      } else {
        setData("");
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const getDepartment = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getDepartment();
      if (result?.success) {
        setDepartmentData(result?.data?.position);

        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleNavigate = () => {
    navigate("/dashboard/manageStaff");
  };

  const getPayslipSetting = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getPayslipSetting();
      if (result?.success) {
        setPayslip(result?.data);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };

  const getProjectList = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getProjectList();
      if (result?.success) {
        setProjectList(result?.data);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleStaffDataExport = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.handleWorkerDataExport(item?._id);
      if (!result || result?.success === false) {
        showAlert(result?.message || "Unable to download staff data PDF.", "error");
        return;
      }
      const downloadError = await getBlobErrorMessage(result);
      if (downloadError) {
        LoaderHelper.loaderStatus(false);
        showAlert(downloadError, "error");
        return;
      }
      const blob = new Blob([result], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      const fileName = item?.employee?.stafId
        ? `staff-${item.employee.stafId}.pdf`
        : `staff-data.pdf`;
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      showAlert(error?.message || "Unable to download staff data PDF.", "error");
    } finally {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleSendProfileEmail = async (email) => {
    if (!email) {
      showAlert("Please enter an email address.", "error");
      return;
    }
    try {
      setEmailSending(true);
      const result = await AuthService.handleWorkerDataExportEmail(item?._id, email);
      if (result?.success === true) {
        showAlert(result?.message || "Profile emailed successfully.", "success");
      } else {
        showAlert(result?.message || "Unable to send email.", "error");
      }
    } catch (error) {
      showAlert(error?.message || "Unable to send email.", "error");
    } finally {
      setEmailSending(false);
    }
  };

  return (
    <ViewEmployeePage
      loading={loading}
      handleMultipleUrl={handleMultipleUrl}
      registerEmployee={updateEmployeeInfo}
      userData={item}
      handleUrl={handleUrl}
      handleNavigate={handleNavigate}
      data={data}
      CountryCode={CountryCode}
      departmentData={departmentData}
      document={documents}
      setDocument={setDocuments}
      payslip={payslip}
      getOneEmployee={getOneEmployee}
      oneEmloyeeData={oneEmloyeeData}
      projectList={projectList}
      handleExportPdf={handleStaffDataExport}
      handleSendEmail={handleSendProfileEmail}
      sendEmailLoading={emailSending}
    />
  );
};

export default EmployeeView;
